// Loader.js
import React from "react";
import "../../assets/css/Loader.scss"; // You can customize the CSS here

const Loader = () => {
  return <div className="loader"></div>;
};

export default Loader;
